import { RDCoverCrop } from '@cibo/core'
import { CoverCropChip, NotObservedChip } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailPanel } from '../DetailPanel'
import { CoverCropPanelTable } from './CoverCropPanelTable'

export const CoverCropPanel = () => {
  const { t } = useTranslation('@cibo/landmanager/CoverCropPanel')

  return (
    <DetailPanel<RDCoverCrop>
      title={t('Cover Crop', { ns: 'clientLocalization' })}
      traitId="coverCrop"
      DetailTable={CoverCropPanelTable}
      DetailIndividual={({ currentYearData }: { currentYearData?: RDCoverCrop }) => (
        <>
          <Stack alignItems="center">
            {!!currentYearData?.input?.crop ? (
              <CoverCropChip crop={currentYearData?.input?.crop} source={currentYearData.source} />
            ) : currentYearData?.result !== undefined ? (
              <CoverCropChip crop={currentYearData.result} source={currentYearData.source} />
            ) : (
              <NotObservedChip />
            )}
          </Stack>
          <Stack>
            <Typography variant="caption">
              {!!currentYearData?.input?.plantedAt && !!currentYearData?.input?.terminatedAt
                ? t('dates', {
                    plantedAt: new Date(currentYearData.input.plantedAt),
                    terminatedAt: new Date(currentYearData.input.terminatedAt),
                  })
                : '--'}
            </Typography>
          </Stack>
        </>
      )}
    />
  )
}
